import { render, staticRenderFns } from "./FloatingBall.vue?vue&type=template&id=03756cbf&scoped=true&"
import script from "./FloatingBall.vue?vue&type=script&lang=js&"
export * from "./FloatingBall.vue?vue&type=script&lang=js&"
import style0 from "./FloatingBall.vue?vue&type=style&index=0&id=03756cbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03756cbf",
  null
  
)

export default component.exports